import Vue from "vue";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

Sentry.init({
  dsn: process.env.VUE_SENTRY_DSN,
  environment: process.env.VUE_SENTRY_ENV,
  integrations: [
    new Integrations.Vue({
      Vue,
      attachProps: true
    })
  ]
});
